import { Button } from '@mui/material';
import 'css/acknowledgementDialog.scss';

const getButtonSx = (backgroundColor: string, includeMargins = false) => {
    const sx: any = {
        textTransform: 'none',
        backgroundColor,
        fontSize: '16px',
    };

    if (includeMargins) {
        sx.margin = '0 2rem 0 5px';
    }

    return sx;
};

interface AccessAcknowledgementDialogProps {
    handleCloseDialog: () => void;
    acceptAcknowledge: () => void;
}

const AccessAcknowledgementDialog = ({ handleCloseDialog, acceptAcknowledge }: AccessAcknowledgementDialogProps) => {
    return (
        <div className='acknowledgement-dialog'>
            <div className='acknowledgement-dialog-content'>
                <div>
                    <h5>
                        <strong>Acknowledgement</strong>
                    </h5>
                </div>
                <br />
                <p>
                    By requesting and using access to the AVA® Provider Portal (“Portal”), I acknowledge and agree to
                    the following:
                </p>
                <ol>
                    <li>
                        <strong>Authorized Access:</strong> I have been authorized by, and am acting solely on behalf
                        of, the medical group, IPA, MSO, hospital, or other provider organization that is contracted
                        with Alignment Health Plan for its HMO and/or PPO lines of business (the “Provider
                        Organization”). Access to and use of the Portal is permitted only for legitimate business
                        purposes related to the Provider Organization’s participation in Alignment’s networks.
                    </li>
                    <li>
                        <strong>Governing Agreement:</strong> I understand that my access to and use of Portal are
                        subject to the terms of the Alignment Provider Portal Access Agreement between Alignment
                        Healthcare and the Provider Organization, which governs all Portal access, permitted uses, and
                        confidentiality obligations. I am not a party to that Agreement but am required to comply with
                        its terms as a condition of my individual access. Alignment may suspend or revoke my access at
                        any time for non-compliance or security reasons.
                    </li>
                    <li>
                        <strong>Registration Information:</strong> I understand that personal information I provide
                        during registration will be used by Alignment to authenticate me as a valid user and may be
                        retained in Alignment’s systems for validation, audit, and reporting purposes. Such information
                        will not be used for other purposes or disclosed to third parties except as required by law.
                    </li>
                    <li>
                        <strong>Credential Security:</strong> I will protect my username and password from unauthorized
                        disclosure or use, will not share my credentials with any other person, and will be responsible
                        for all activities performed under my credentials. I will use only secure, Provider
                        Organization-managed devices to access the Portal. If I believe my password has been
                        compromised, I will immediately change it and notify both my employer (or Provider Organization)
                        and Alignment.
                    </li>
                    <li>
                        <strong>Confidentiality and Compliance:</strong> I will comply with all applicable laws,
                        including HIPAA, and with all security, privacy, and confidentiality requirements contained in
                        the Provider Portal Access Agreement. I will access and use any information obtained through the
                        Portal—including Protected Health Information (“PHI”)—only as necessary for authorized
                        treatment, payment, or healthcare operations, and in accordance with the “minimum necessary”
                        standard under HIPAA. I will not download, copy, or transmit PHI except as permitted by law and
                        by the Provider Portal Access Agreement. I will immediately report to both Alignment and my
                        employer any suspected misuse, unauthorized disclosure, or misdirected PHI.
                    </li>
                    <li>
                        <strong>Monitoring and Enforcement:</strong> I understand that Alignment may monitor Portal
                        access and activity to ensure compliance, and that any misuse, unauthorized access, or violation
                        of this Acknowledgement may result in suspension or termination of Portal privileges, reporting
                        to my employer, or other action permitted under law.
                    </li>
                </ol>
                <p>
                    By clicking <strong>“I Agree”</strong>, I certify that I have read and understand this
                    Acknowledgement and agree to comply with it.
                </p>
            </div>
            <div className='e-footer-content'>
                <Button
                    type='button'
                    className='e-cancel'
                    sx={getButtonSx('#767679')}
                    onClick={handleCloseDialog}
                >
                    Cancel
                </Button>
                <Button
                    type='button'
                    className='e-submit'
                    name='Create'
                    sx={getButtonSx('#03659a', true)}
                    onClick={acceptAcknowledge}
                >
                    I Agree
                </Button>
            </div>
        </div>
    );
};

export default AccessAcknowledgementDialog;
